export default __webpack_public_path__ + "static/affiliate-program-PartnersAre-2-0284eb4aa942f4cb625b9036c7ebb870.svg";